import {
  CONFIRMED_GET_STOCK_TRANSACTIONS,
  STOCK_TRANSACTIONS_LOADING,
  STOCK_TRANSACTIONS_ERROR,
} from "../types/stockTransactionTypes";
import { getStockTransactionsList } from "../../services/StockTransactionService";
import { showErrorAlert } from "../../services/ErrorHandlingService";

// Format transaction data from API response
export function formatStockTransactions(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((transaction) => ({
      id: transaction.id || transaction.transaction_id,
      date: transaction.date || transaction.transaction_date || transaction.created_at?.split("T")[0],
      medicine_name: transaction.medicine_name || transaction.medicine?.name,
      batch_no: transaction.batch_no,
      carton_id: transaction.carton_id,
      transaction_type: transaction.transaction_type || transaction.type,
      qty: transaction.qty || transaction.quantity,
      balance_qty: transaction.balance_qty || transaction.balance_quantity,
    }));
  }
  return [];
}

export function getStockTransactionsAction(pagination = true, pageid = 0, search_by = "", search_keyword = "", sort_by = "", sort_order = "") {
  return async (dispatch) => {
    try {
      dispatch({ type: STOCK_TRANSACTIONS_LOADING });

      const response = await getStockTransactionsList(pagination, pageid, search_by, search_keyword, sort_by, sort_order);
      
      if (response?.status === 200 && response?.data?.status === "success") {
        const transactions = formatStockTransactions(response.data.data);
        dispatch({
          type: CONFIRMED_GET_STOCK_TRANSACTIONS,
          payload: {
            transactions,
            num_rows: response.data.num_rows || 0
          }
        });
        return { success: true, data: transactions };
      } else {
        throw new Error(response?.data?.message || "Failed to fetch stock transactions");
      }
    } catch (error) {
      console.error("Get stock transactions error:", error);
      dispatch({ type: STOCK_TRANSACTIONS_ERROR, payload: error.message });
      showErrorAlert(error.message || "Failed to fetch stock transactions");
      throw error;
    }
  };
}